import { useTranslation } from "react-i18next";
import { Button } from "@nexus/ui";

export interface ReportBackLinkProps {
  onBack: () => void;
}

/** Compact inline back affordance — sits above the report title, not on its own row. */
export function ReportBackLink({ onBack }: ReportBackLinkProps) {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      variant="link"
      size="sm"
      iconStart="arrow-left"
      onClick={onBack}
      className="text-muted-foreground h-auto w-fit justify-start gap-1 self-start p-0 text-xs font-normal hover:text-foreground"
    >
      {t("preflight.report.backShort")}
    </Button>
  );
}
